import posthog from 'posthog-js';

export function initPostHog() {
  // No key configured (e.g. local dev without a .env) — skip init so we don't
  // call posthog.init(undefined, ...) and silently no-op.
  if (!import.meta.env.VITE_POSTHOG_KEY) {
    return;
  }

  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    autocapture: true,
    capture_exceptions: true,
    capture_pageview: false, // handled manually via PostHogPageView for SPA routing
    person_profiles: 'identified_only',
  });
}

export default posthog;
